export default __webpack_public_path__ + "static/media/menu-meteor-7.60e7c041.png";